import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { LinkComponent } from '@app/shared/components/link/link.component';
import { StringMap } from '@app/utils/string-map';
import { BootstrapViewport } from '@app/utils/viewport';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'portal-sub-nav-item',
  templateUrl: './sub-nav-item.component.html',
  host: {
    class: 'nav-item',
  },
  standalone: false,
})
export class SubNavItemComponent implements OnInit {
  @Input()
  activeRoutes?: string[];

  @Input()
  disableTooltip: boolean = false;

  @Input()
  params: StringMap<any>;

  @Input()
  route: string;

  @Input()
  routeExact: boolean = true;

  @Input()
  title: string;

  @ContentChild(TemplateRef)
  content: TemplateRef<any>;

  @ViewChild(LinkComponent)
  link: LinkComponent;

  @Output()
  click = new EventEmitter<void>();

  public tablet: boolean = false;

  public ngOnInit() {
    BootstrapViewport.size$.pipe(untilDestroyed(this)).subscribe((size) => {
      this.tablet = size === 'xs' || size === 'sm' || size === 'md';
    });
  }

  public emit() {
    this.click.emit();
  }
}
